var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._l((_vm.images),function(item,index){return _c('img',{key:index,staticClass:"image",attrs:{"src":item.imageSrc,"mode":"aspectFill"}})}),_vm._v(" "),_c('TopPage',{attrs:{"content":_vm.data.topPage}}),_vm._v(" "),_c('Operation',{attrs:{"operationInfo":_vm.data.operation}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8768e7e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/channelServices/ChannelServices.vue
// module id = null
// module chunks = 